import OtpInput from "react-otp-input";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as GreenTick } from "../../img/icons/icon_tick_green.svg";
import BackButton from "../../img/icons/icon_blue_back.svg";
import { Modal } from "react-bootstrap";
import NavigateBack from "../../components/navigateBack";
import OTP from "../../components/otp";

function UpdateMobileOtp({ newTokenOTP, toVerifyNumber, setNewTokenOTP }) {
  const [otp, setOtp] = useState({ otp: "" });
  const { t } = useTranslation();
  const history = useHistory();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleClose = () => {
    setShowSuccessModal(false);
    history.push("/setting");
  };
  const handleShow = () => setShowSuccessModal(true);
  const token = "Bearer " + localStorage.getItem("token");

  const verifyOTP = async (otpData) => {
    const patientId = JSON.parse(localStorage.getItem("pid"));
    const POST_URL = `/api/v1/users/profile/mobile/${patientId}`;
    const data = {
      tid: newTokenOTP.tid,
      otp: otpData.otp,
    };
    return fetch(`${POST_URL}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
        Authorization: token.replace(/['"]+/g, ""),
      },
      body: JSON.stringify(data),
      credentials: "include",
    }).then((response) => response.json());
  };

  const submitHandler = (data) => {
    // Logic when things are successful
    handleShow();
  };

  const resendOTP = (toVerifyNumber) => {
    const token = "Bearer " + localStorage.getItem("token");
    const POST_URL = `/api/v1/users/profile/mobile/otp/${toVerifyNumber}`;
    return fetch(`${POST_URL}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
        Authorization: token.replace(/['"]+/g, ""),
      },
      body: JSON.stringify(),
      credentials: "include",
    })
      .then((response) => response.json())
      .then((responseData) => {
        console.log(responseData);
        //TODO: Save to localstorage as well? Check with Ishaq
        setNewTokenOTP(responseData);
        //if (responseData["status"]["success"]) {setToken(responseData["tid"]);}
      })
      .catch((error) => console.log(error));
  };

  return (
    <>
      <NavigateBack onClickHandler={() => history.push("/update-mobile")} />
      <OTP
        question={t("onboard.VERIFY_MOBILE.question")}
        toVerify={toVerifyNumber}
        verifyCall={verifyOTP}
        onSubmitHandler={submitHandler}
        patientId=""
        resendOTPCall={resendOTP}
        goBackHandler={() => history.push("/update-mobile")}
        ctaText={t("appointment.BUTTON.verify")}
      />
      {/* <div className="custom_modal modal fade text-center" id="modal_otp">
                <div className="modal-dialog d-flex align-items-center top-0">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0">
                            <button
                                id="modal_otp"
                                type="button"
                                className="btn-close btn-dark-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => history.push("/setting")}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="content_modal text-start p-2">
                                <h3 className="maintitle maintitle_txt_color_black text-center pb-3">
                                {t('sidenav.VERIFY_MOBILE.message')}
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
      <Modal centered show={showSuccessModal} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="text-center react_modal">
          {t("sidenav.VERIFY_MOBILE.message")}{" "}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UpdateMobileOtp;
